export default function ContentSection() {
  return (
    <section className="bg-white py-10 sm:py-14 lg:py-20">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="space-y-8 font-sans text-sm leading-relaxed text-gray-700 sm:space-y-10 sm:text-base lg:space-y-12">
          {/* I. Legal */}
          <div>
            <h2 className="mb-4 text-2xl font-bold text-[#16a34a] sm:mb-5 sm:text-3xl lg:mb-6">
              I. Legal
            </h2>
            <p>
              Welcome to the Refex Renewables Infrastructure Limited (&quot;Refex Renewables&quot;) website. Please review the following terms and conditions concerning your use of this site. By accessing, using or downloading content from this website you agree to follow and be bound by these terms and conditions. Refex Renewables reserves the right to change these terms and conditions from time to time at its sole discretion. Therefore, you should periodically visit this page to review the then current terms and conditions to which you are bound. In the case of any violation of the terms and conditions set forth herein, Refex Renewables reserves the right to seek all remedies available by law and in equity for such violations. These terms and conditions apply to all visits to the Refex Renewables website, both now and in the future.
            </p>
          </div>

          {/* II. Use */}
          <div>
            <h2 className="mb-4 text-2xl font-bold text-[#16a34a] sm:mb-5 sm:text-3xl lg:mb-6">
              II. Use
            </h2>
            <p className="mb-4">
              You may not use, download or copy any content on this website unless:
            </p>
            <ul className="mb-4 list-disc space-y-2 pl-4 sm:pl-6">
              <li>You use the content solely for personal, informational and non-commercial purposes;</li>
              <li>The Refex Renewables trademark and copyright symbol and statement set forth on each page of this website appears on each downloaded or copied page; and</li>
              <li>No modifications are made to any content.</li>
            </ul>
            <p>
              The rights granted to you constitute a license and not a transfer of title. Refex Renewables reserves the right to revoke the authorization to view, download and print the content available on this website at any time, and any such use shall be discontinued immediately upon written notice from Refex Renewables. Except as expressly provided herein, you may not use, download, upload, copy, print, display, perform, reproduce, publish, license, post, transmit or distribute any content from this website in whole or in part without the prior written permission of Refex Renewables. You may not &quot;mirror&quot; any content contained on this website on any other server without Refex Renewables&apos;s prior express written permission. Any unauthorized use of any content contained on this website may violate copyright laws, trademark laws, the laws of privacy and publicity, and communications regulations and statutes. Any rights not expressly granted herein are reserved by Refex Renewables.
            </p>
          </div>

          {/* III. Copyright */}
          <div>
            <h2 className="mb-4 text-2xl font-bold text-[#16a34a] sm:mb-5 sm:text-3xl lg:mb-6">
              III. Copyright
            </h2>
            <p className="mb-4">
              All content, images, designs, logos, and other intellectual property appearing on this website is the property of Refex Renewables unless otherwise stated. Refex Renewables retains copyright on all the text, contents, graphics and trademarks displayed on this website.
            </p>
            <p>
              All rights reserved. All text, electronic documents, graphics, audio, video and other content published on this site are protected by the laws of India. By accessing and using this website, you agree to abide by the laws of India and all other applicable laws. Distribution or publication of any of this site&apos;s content in any form without prior written permission of Refex Renewables is expressly forbidden.
            </p>
          </div>

          {/* IV. Trademarks */}
          <div>
            <h2 className="mb-4 text-2xl font-bold text-[#16a34a] sm:mb-5 sm:text-3xl lg:mb-6">
              IV. Trademarks
            </h2>
            <p className="mb-4">
              The trademarks, logos, product names, trade name (collectively the &quot;Trademarks&quot;) displayed on the website are registered and unregistered trademarks of Refex Renewables. No additional rights are granted by implication, estoppel, or otherwise.
            </p>
            <p className="mb-4">
              You are not permitted to use these trademarks, or any other Refex Renewables trademarks, without the prior written consent of Refex Renewables.
            </p>
            <p>
              All other trademarks, product names, trade names, and logos used within these pages are the property of their respective holders. Use of other company/entity trademarks, trade names, product names and logos or images of the same does not necessarily constitute:
            </p>
            <ul className="mt-2 list-disc space-y-2 pl-4 sm:pl-6">
              <li>An endorsement by such company of Refex Renewables and its products, and</li>
              <li>An endorsement of the company or its products by Refex Renewables.</li>
            </ul>
          </div>

          {/* V. Links to Third Party Sites */}
          <div>
            <h2 className="mb-4 text-2xl font-bold text-[#16a34a] sm:mb-5 sm:text-3xl lg:mb-6">
              V. Links to Third Party Sites
            </h2>
            <p>
              This website may contain hyperlinks to websites that are not controlled by Refex Renewables. Refex Renewables is not responsible for and does not make any representation and warranties express or implied over the contents or use of these websites, including, without limitation, the accuracy or reliability of any information, data, opinions, advice or statements made on these websites.
            </p>
          </div>

          {/* VI. No Unlawful or Prohibited Use */}
          <div>
            <h2 className="mb-4 text-2xl font-bold text-[#16a34a] sm:mb-5 sm:text-3xl lg:mb-6">
              VI. No Unlawful or Prohibited Use
            </h2>
            <p>
              As a condition of your use of this website, you agree that you will not use this website or the content contained herein for any purpose that is unlawful or prohibited by these terms and conditions.
            </p>
          </div>

          {/* VII. Disclaimer */}
          <div>
            <h2 className="mb-4 text-2xl font-bold text-[#16a34a] sm:mb-5 sm:text-3xl lg:mb-6">
              VII. Disclaimer
            </h2>
            <p className="mb-4">
              While every effort is made to ensure the accuracy of content offered on these pages, Refex Renewables assumes no legal liability or responsibility whatsoever for the accuracy, completeness, or usefulness of any such information and hereby disclaims any and all liability to any person for any actual or threatened loss or damage caused by errors or omissions, whether such errors or omissions result from negligence, accident or otherwise.
            </p>
            <p className="mb-4">
              This website could include inaccuracies or out-dated content and is subject to change at any time without notice. Your use of this website is at your own risk. You agree to hold Refex Renewables harmless from and not sue Refex Renewables for any claims based upon using this website.
            </p>
            <p className="mb-4 text-sm font-semibold sm:text-base">
              THE CONTENT, DOCUMENTATION, PRODUCTS, AND SERVICES CONTAINED ON THE Refex Renewables WEBSITE ARE PROVIDED ON &quot;AS IS BASIS&quot; Refex Renewables MAKES NO REPRESENTATIONS OR WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE OR NON-INFRINGEMENT OF THIRD-PARTY RIGHTS.
            </p>
            <p className="mb-4 text-sm font-semibold sm:text-base">
              WITHOUT ANY WARRANTY OF ANY KIND. Refex Renewables AND ITS SUPPLIERS DISCLAIM ALL WARRANTIES RELATING TO THE CONTENT, DOCUMENTATION, PRODUCTS, AND SERVICES CONTAINED ON THE Refex Renewables WEB SITE, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, ANY WARRANTIES AGAINST INFRINGEMENT OF THIRD-PARTY RIGHTS, MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE OR ARISING FROM A COURSE OF DEALING, USAGE, OR TRADE PRACTICE.
            </p>
            <p className="text-sm font-semibold sm:text-base">
              Refex Renewables AND ITS SUPPLIERS SHALL NOT BE LIABLE FOR ANY INDIRECT, SPECIAL, CONSEQUENTIAL, OR INCIDENTAL DAMAGES INCLUDING, WITHOUT LIMITATION, LOST PROFITS OR REVENUES, COSTS OF REPLACEMENT GOODS, LOSS OR DAMAGE TO DATA ARISING OUT OF THE USE OR INABILITY TO USE THIS SITE, DAMAGES RESULTING FROM USE OF OR RELIANCE ON THE INFORMATION PRESENT, EVEN IF Refex Renewables OR ITS SUPPLIERS HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            </p>
          </div>

          {/* VIII. Governing Law */}
          <div>
            <h2 className="mb-4 text-2xl font-bold text-[#16a34a] sm:mb-5 sm:text-3xl lg:mb-6">
              VIII. Governing Law
            </h2>
            <p>
              Any claim or dispute relating to your use or attempted use of this website shall be governed by and construed in accordance with the laws India, without giving effect to its conflict of law&apos;s provisions. By using this Web site, you submit to the exclusive jurisdiction of courts of Chennai in any proceeding relating to any such claim or dispute.
            </p>
          </div>

          {/* Copyright */}
          <div className="border-t border-gray-200 pt-6 sm:pt-8">
            <p className="text-xs text-gray-600 sm:text-sm">
              Copyright © 2021 Refex Renewables. All rights reserved
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
